import { LogoutModalTranslations } from "./types";

export const enTranslations: LogoutModalTranslations = {
    title: "Attention!",
    gameSubtitle: "Are you sure? Leaving the game now means you won't be able to return.",
    subtitle: "Are you sure?",
    logoutText:"Logout",
    cancelText:"Cancel"
};